/**
 * Copyright (c) 2021-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

export const ACTIVE_SUBJECTS = "active";
export const ARCHIVE_SUBJECTS = "archive";
export const BETA_SUBJECTS = "beta";
export const OTHER = "otherResources";

export const subjectCategories = {
  ACTIVE_SUBJECTS,
  ARCHIVE_SUBJECTS,
  BETA_SUBJECTS,
  OTHER,
} as const;

export type SubjectCategory = (typeof subjectCategories)[keyof typeof subjectCategories];
